import { Component, Input, OnChanges, SimpleChanges} from '@angular/core';

/**
   * Logger Factory
   * @namespace stopAnimation: if true the animation is stopped
   * @namespace icon: is the icon to show inside the spinner
   * ES:
   * <ute-icon-spinner class="pippo" [stopAnimation]="stopAnimation" icon="call"></ute-icon-spinner>
*/

@Component({
  selector: 'ute-icon-spinner',
  templateUrl: 'ute-icon-spinner.component.html'
})
export class UteIconSpinnerComponent implements OnChanges  {
  @Input() stopAnimation: boolean;
  @Input() icon: boolean;
  public newIcon: string; 

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change: SimpleChanges){
    if(change && change.icon){
      this.newIcon = change.icon.currentValue;
    }
  }
  
}


// WEBPACK FOOTER //
// ./src/app/components/atoms/ute-icon-spinner/ute-icon-spinner.component.ts